import React from 'react'
import { Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AboutPage from './AboutPage'
import ProjectsPage from './ProjectsPage'
import ContactPage from './ContactPage'
import Header from '../components/Header'
import Socials from '../components/Socials';

const HomePage = () => {

    return (
        <div>
            <Hidden mdDown>
                <Socials/>  
            </Hidden>
            <Header/>
            <AboutPage/>
            <ProjectsPage/>
            <ContactPage/>
        </div>
    )
}

export default HomePage
